// 使用
// import EnterpriseNoSetting from "@/utils/EnterpriseNoSetting.js";
// const commonJumpKeys = ref(EnterpriseNoSetting.keys);
// const commonJumpURL = ref(EnterpriseNoSetting.URL);



// 多租户的配置   EnterpriseNoSetting
let getEnterpriseNo = window.localStorage.getItem('EnterpriseNo') || ''
console.log('getEnterpriseNo', getEnterpriseNo)

let isWaitNoticeSend = 1;  //是否等通知放货 1==扣货, 0==放货
let showSQD_YEHX = false; //是否显示申请单余额核销
let BatchModificationMembership = false //批量修改会员资料
let toFixedNum = 3 //保留小数位
let showSelectBillUrl = false //合作商是否显示查件网址
let kCShowCRK = false //库存列表是否展示出入库确定按钮
let organizationShowZJLSH = false //组织架构是否维护前缀字符和流水号
let isAllDept = false //下拉列表是否查所有(部门+网点),默认只查部门
let isShowimportExportTypeShow = false //是否显示进出口类型
let updateStatementNumber = false //是否可以修改对账单号

// if (getEnterpriseNo === 'jy' || getEnterpriseNo === 'jy_01') {
//     isShowPrintWaybill = false
//     showStartDeptId = true
//     showEndDeptId = true
//     BatchModificationMembership = true
//     toFixedNum = 2
// }


export default {
    URL: {

    },
    keys: {
        isWaitNoticeSend, //是否等通知放货 1==扣货, 0==放货
        showSQD_YEHX, // 是否显示申请单余额核销
        BatchModificationMembership, // 批量修改会员资料 按钮
        toFixedNum, //保留的小数位
        showSelectBillUrl, //合作商是否显示查件网址
        kCShowCRK, //合作商是否显示查件网址
        organizationShowZJLSH, //组织架构是否维护前缀字符和流水号
        isAllDept, //下拉列表是否查所有(部门+网点),默认只查部门
        isShowimportExportTypeShow, //是否显示进出口类型
        updateStatementNumber, //是否可以修改对账单号
    }
}